/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_LINKEDIN': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M3.66 1.85a1.84 1.84 0 0 1-1.83 1.84 1.85 1.85 0 0 1 0-3.69 1.84 1.84 0 0 1 1.83 1.85zM.3 15h3.09V5H.3zm8-10h-3v10h3V9.75c0-1.41.65-2.24 1.89-2.24s1.69.8 1.69 2.24V15H15V8.67c0-2.68-1.52-4-3.64-4a3.51 3.51 0 0 0-3 1.65z" _fill="#545454" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_LINKEDIN.js